import { PEER } from '../constants'
import { values } from 'lodash/fp'

/**
 * Checks whether the current sdp semantics is unified-plan
 * @method isUnifiedPlan
 * @param {String} sdpSemantics The current sdp semantics being used
 * @return {Boolean}
 */
export function isUnifiedPlan (sdpSemantics) {
  return sdpSemantics === PEER.SDP_SEMANTICS.UNIFIED_PLAN
}

/**
 * Generates a list of sdp semantics.
 * @method getSdpSemanticsList
 * @return {Array}
 */
export function getSdpSemanticsList () {
  return values(PEER.SDP_SEMANTICS)
}
